import { SparkIteration, SparkLibraryItem, EditorCapabilities } from '../types/sparkTypes';

/**
 * Adapt a SparkLibraryItem to an iteration-like object that existing editors can consume.
 * This does not include feedback/jobs fields and uses neutral placeholders where needed.
 */
export function adaptLibraryItemToIteration(item: SparkLibraryItem): SparkIteration {
  return {
    fqn: item.fqn,
    _creative_fqn: '',
    _creative_type_fqn: item.creative_type_fqn,
    _iteration_number: 0,
    name: item.title || '',
    description: item.description || '',
    values: (item as any).values || {},
    images: (item as any).images || {},
    validation_issues: (item as any).validation_issues || {},
    elements_definition_version: item.elements_definition_version || null,
    _rationale: null,
    _feedback: [],
    _resource_fqns: [],
    ancestor_iteration_fqns: [],
    _generating_job_fqn: null,
    _supported_export_types: [],
    _updated_at: item._updated_at || null,
    _changed_at: item._changed_at || null,
    _created_at: item._created_at || null,
    _last_time_seen: null,
  } as unknown as SparkIteration;
}

/**
 * Compute editor capability flags for a library item, given current user context.
 */
export function getLibraryItemCapabilities(
  item: SparkLibraryItem,
  currentUserFqn: string | null | undefined,
  isTenantAdmin: boolean
): EditorCapabilities {
  const isOwner = !!currentUserFqn && !!item.owner_fqn && currentUserFqn === item.owner_fqn;
  const isPublished = item.state === 'published';

  const canEdit = !isPublished && (isOwner || isTenantAdmin);

  return {
    canEditValues: canEdit,
    canEditMedia: canEdit,
    canUseMediaAI: false, // AI media actions disabled for items per design
    canChat: false,       // Chat disabled for items per design
    canPublish: !isPublished && isOwner, // only owner can publish
    canUnpublish: isPublished && (isOwner || isTenantAdmin),
    canDelete: isOwner || isTenantAdmin,
  };
}

